import {request} from './repository';

const url = 'collaborators/';

const collaboratorRepository = {
    getCollaborators(params) {
        return request.get(url, params);
    },
    storeCollaborator(data) {
        return request.post('create-collaborator', data);
    },
    getCollaborator(id) {
        return request.get(url + id);
    },
    updateCollaborator(id, data) {
        let form = _.pick(data, ['registration_id', 'start_date', 'collaborator_function_id', 'organization_id', 'end_date', 'collaborator_organization_id', 'current_organization', 'email', 'email_confirmation'])
        return request.put(url + id, form);
    },
    deleteCollaborator(id) {
        return request.delete(url + id);
    },
    addCollaboration(data) {
        return request.post(url, data);
    },
    removeCollaboration(id, data) {
        return request.post(url + `remove-collaboration/${id}`, data)
    },
    listCollaboratorsByOrganization(organization_id) {
        return this.getCollaborators({organization_id});
    },
    listByOrganizations(data) {
        return request.post(url + 'list-by-organizations', {
            source_procedure_situation_id: data
        });
    },
    createCollaborator(data) {
        let form = _.pick(data, ['start_date', 'collaborator_function_id', 'registration_id', 'person_id', 'end_date', 'organization_id', 'email', 'email_confirmation'])
        return request.post(url, form)
    }
}

export default collaboratorRepository;
